import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box, Button, Card, CardActionArea, CardActions, CardContent, CardMedia, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { get } from 'lodash';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import NotFoundImage from '../../../../../assets/images/404_image.png';
import MarkdownRenderer from '../../../../../components/ui-component/markdown-renderer/MarkdownRenderer';
import { PAGES_URLS } from '../../../../../lib/constants/routes';
import { STRAPI_URL } from '../../../../../lib/constants/url';
import { FoerderProgrammProps } from '../../../../../lib/types/types';

// import Schemas
import { isArray } from 'lodash';
import FOERDERPROGRAMM_PATHS from '../../../../../lib/paths/ausschreibung_FULL_Paths.json';
const P = FOERDERPROGRAMM_PATHS.attributes;

const FoerderProgrammGrid: FC<FoerderProgrammProps> = ({ data }) => {
	const navigate = useNavigate();

	const getImageUrl = (index: number) => {
		const imageUrl = get(data[index], 'attributes.Ausschreibungen_Logo.attributes.url');
		if (imageUrl) {
			return `${STRAPI_URL}${imageUrl}`;
		} else {
			return NotFoundImage;
		}
	};

	if (isArray(data) && (data || []).length > 0) {
		return (
			<>
				<Grid container spacing={5} columns={3}>
					{(data || []).map((ele, i) => (
						<Grid xs={3} sm={1.5} md={1} key={i}>
							<Card
								raised
								sx={{
									maxWidth: '25rem',
									borderRadius: 1,
									overflow: 'hidden',
									boxShadow: '0 1px 1px rgba(0,0,0,0.2)',
									transition: 'transform 0.2s ease-in-out',
									cursor: 'pointer',
									'&:hover': {
										transform: 'translateY(-1px)',
										boxShadow: 1,
									},
								}}
								onClick={() => navigate(`${PAGES_URLS.FoerderProgrammDetails}`, { state: { id: get(ele, 'id', -1) } })}
							>
								<CardActionArea component='div'>
									<Box
										position='relative'
										sx={{
											width: '100%',
											height: 265,
											backgroundColor: '#f9f9f9',
											'&:hover .hover-caption': {
												opacity: 1,
											},
										}}
									>
										<CardMedia
											component='img'
											height={265}
											image={getImageUrl(i)}
											alt={get(ele, P.Ausschreibungen_Logo_Alt_Text.path) ?? `Ausschreibungs-logo- ${get(ele, P.Programmname.path, '')}`}
											sx={{ width: '100%', height: '100%' }}
										/>
										<Box
											className='hover-caption'
											position='absolute'
											bottom={0}
											width='100%'
											bgcolor='rgba(0,0,0,0.6)'
											color='white'
											px={1}
											py={0.5}
											textAlign='center'
											sx={{
												opacity: 0,
												transition: 'opacity 0.3s',
											}}
										>
											<Typography variant='caption'>
												{get(ele, P.Ausschreibungen_Logo_Alt_Text.path) ?? `Ausschreibungs-logo- ${get(ele, P.Programmname.path, '')}`}
											</Typography>
										</Box>
									</Box>
									<Box sx={{ backgroundColor: '#f9f9f9' }}>
										<CardContent>
											<Typography gutterBottom variant='h6' component={'h2'} sx={{ fontWeight: 500, color: 'primary.main' }}>
												{get(ele, P.Programmname.path, '')}
											</Typography>
											<Typography
												variant='body2'
												color='text.secondary'
												component='div'
												sx={{
													height: '8rem',
													lineHeight: '1.4rem',
													overflow: 'hidden',
													display: '-webkit-box',
													WebkitBoxOrient: 'vertical',
													WebkitLineClamp: 5,
													fontSize: '0.9rem',
													textOverflow: 'ellipsis',
												}}
											>
												<MarkdownRenderer markdown={get(ele, P.Kurzbeschreibung.path, '')} />
											</Typography>
										</CardContent>
										<CardActions>
											<Button endIcon={<KeyboardArrowRightIcon />}>Mehr erfahren</Button>
										</CardActions>
									</Box>
								</CardActionArea>
							</Card>
						</Grid>
					))}
				</Grid>
			</>
		);
	} else {
		return (
			<>
				<Typography>Keine Ergebnisse</Typography>
			</>
		);
	}
};

export default FoerderProgrammGrid;
